/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon6IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon6Icon(props: Icon6IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 32"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        fillRule={"evenodd"}
        d={
          "M5.485 1.978 7.52 0 9.6 2 7.53 3.975zm8.61 6.61q-.002 2.489-1.274 3.912-.804.885-2.088 1.346a8.7 8.7 0 0 1-2.886.434h-1.48q-1.684 0-3.036-.594a5.45 5.45 0 0 1-2.4-1.967 5.97 5.97 0 0 1-.93-3.327c0-.158.003-.312.011-.47.08-1.466.544-3.086 1.4-4.87l2.918 1.29q-1.028 2.129-1.117 3.74a6 6 0 0 0-.01.32q-.001 1.008.442 1.648c.318.463.79.797 1.333.943q.341.112.741.16.316.04.648.038h1.48q1.83 0 2.487-.65.56-.557.56-1.95V2.72h3.198v5.87zm14.483 8.489-1.92-1.867 1.89-1.881 1.96 1.884zm-7.613.82q2.166.001 3.446 1.517 1.187 1.384 1.186 3.447v.97h.48v-.01h1.093q.885 0 1.245-.224c.248-.147.373-.373.373-.688v-.184c.011-.648.046-2.783 0-2.972l3.202-.96v4.196c.008.83-.261 1.64-.765 2.3q-1.223 1.62-3.985 1.619h-1.672q-.246 2.93-2.977 4.193-1.07.487-2.498.706-1.211.185-2.437.179v-3.09q2.448.001 3.679-.658 1-.527 1.002-1.33h-1.372q-1.744 0-2.968-.904-1.466-1.093-1.466-3.146 0-1.95.979-3.305 1.183-1.658 3.454-1.658zm1.42 5.935v-.97q-.001-.87-.38-1.376a1.24 1.24 0 0 0-1.04-.499 1.27 1.27 0 0 0-1.056.499 1.88 1.88 0 0 0-.363 1.197q0 .09.008.178a.88.88 0 0 0 .472.755q.371.214.939.213zm.275-8.619 1.92 1.866 1.93-1.866-1.96-1.884zM4.816 28.243h.08q1.73-.038 2.497-.773c.064.032.174.094.32.181l.197.104.216.112q.54.293 1.01.48 1.379.586 2.605.587a3.24 3.24 0 0 0 2.32-.907q1.197-1.14 1.196-3.428a5.84 5.84 0 0 0-.893-3.052Q13.17 19.72 10.9 19.72q-2.007 0-3.311 1.533-.45.528-.784 1.215c-.085.166-.16.333-.224.51q-.048.1-.08.207l-.058.16q-.412 1.235-.547 1.413-.287.362-1.138.392-.493-.019-.682-.203-.228-.215-.227-.791v-8.163L.646 14.661v9.496q0 1.044.382 1.874.284.632.773 1.1.491.472 1.146.747.793.337 1.773.363v.002zm7.336-2.703c.11-.3.151-.622.117-.94a2.3 2.3 0 0 0-.44-1.254q-.4-.535-.933-.535c-.48 0-.88.274-1.191.826q-.168.284-.304.698a7 7 0 0 0-.107.32l-.04.141-.04.123q.567.473 1.45.781.722.246 1.154.245.178.002.334-.405"
        }
        clipRule={"evenodd"}
      ></path>
    </svg>
  );
}

export default Icon6Icon;
/* prettier-ignore-end */
